import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { AppLink } from '@finect/tabular-core/AppLink';
export var Organizations = styled.div.withConfig({
  displayName: "partials__Organizations",
  componentId: "sc-12cru09-0"
})(["", ";"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 24px;\n  "]))));
export var ClaimBlock = styled.div.withConfig({
  displayName: "partials__ClaimBlock",
  componentId: "sc-12cru09-1"
})(["margin-bottom:24px;"]);
export var OrganizationContainer = styled.div.withConfig({
  displayName: "partials__OrganizationContainer",
  componentId: "sc-12cru09-2"
})(["width:100%;margin-bottom:20px;", ";"], minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));
export var OtherAction = styled(AppLink).withConfig({
  displayName: "partials__OtherAction",
  componentId: "sc-12cru09-3"
})(["cursor:pointer;"]);
export var FeaturedOrganizations = styled.div.withConfig({
  displayName: "partials__FeaturedOrganizations",
  componentId: "sc-12cru09-4"
})(["display:grid;grid-template-colums:1fr;gap:8px 0;width:100%;", ";"], minMediaQueries.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-template-columns: ", ";\n    gap: 8px 16px;\n  "])), function (_ref) {
  var items = _ref.items;
  return items > 1 ? '1fr 1fr' : '1fr';
}));